
import { IGetSponsors, IGetSponsorsRes } from '../../models/admin/sponsors.model';
import deleteService from '../deleteService';
import getService from '../getService';
import postService from '../postService';
import putService from '../putService';


const CONFIG_API_URL =
process.env.REACT_APP_API_BASE_URL || 'http://20.126.75.78/naptin/api/v1/';

const GETSPONSORS = 'sponsors';
const GETSPONSORSBUDGET ='sponsors-budget'
const SPONSORANALYTICS ='sponsors-analytics'
const BATCHSPONSORS = 'admin/sponsors-batch'

export default class SponsorService {
 
  static async getSponsors(filter:any) {
    // const response = await getService.get(CONFIG_API_URL + GETSPONSORS );
    const response = await getService.get(`${CONFIG_API_URL}sponsors${filter}`);
    const data :any = response.data
    return data;
  }
  static async getEachSponsor(uuid:string | undefined) {
    const response = await getService.get(CONFIG_API_URL + GETSPONSORS + '/' + uuid);
    const data :IGetSponsors = response.data.data
    return data;
  }
  static async getSponsorAnalytics() {
    const response = await getService.get(CONFIG_API_URL + SPONSORANALYTICS);
    const data :any = response.data
    return data;
  }
  static async getSponsoredTrainees(uuid:string | undefined) {
    const response = await getService.get(CONFIG_API_URL + GETSPONSORS + '/' + uuid + '/trainees');
    const data :any = response.data
    return data;
  }
  static async createSponsor(data: any) {
    const response = await postService.post(`${CONFIG_API_URL}${GETSPONSORS}`, data);
    return response.data;
  }
  static async batchUploadSponsor(data: any) {
    const response = await postService.post(`${CONFIG_API_URL}${BATCHSPONSORS}`, data);
    return response.data;
  }
  static async updateSponsor(data: any,uuid:string) {
    const response = await putService.put(`${CONFIG_API_URL}${GETSPONSORS}/${uuid}`, data);
    return response.data;
  }
  static async deleteSponsor(uuid:string) {
    const response = await deleteService.delete(`${CONFIG_API_URL}${GETSPONSORS}/${uuid}`);
    return response.data;
  }
  static async batchSponsorTrainees(uuid: any,data:any) {
    const response = await postService.post(`${CONFIG_API_URL}${GETSPONSORS}/${uuid}/trainees`, data);
    return response.data;
  }

  static async approveSponsorTrainees(uuid: any,data:any) {
    const response = await postService.post(`${CONFIG_API_URL}${GETSPONSORS}/${uuid}/approve-trainees`, data);
    return response.data;
  }

  static async declineSponsorTrainees(uuid: any, data:any) {
    const response = await postService.post(`${CONFIG_API_URL}${GETSPONSORS}/${uuid}/reject-trainees`, data);
    return response.data;
  }

  static async getSponsorsBudget() {
    const response = await getService.get(CONFIG_API_URL + GETSPONSORSBUDGET);
    const data :any = response.data
    return data;
  }
  static async getEachSponsorBudget(uuid:string | undefined) {
    const response = await getService.get(CONFIG_API_URL + GETSPONSORSBUDGET + '/' + uuid);
    const data :any = response.data
    return data;
  }
  static async createSponsorBudget(data: any) {
    const response = await postService.post(`${CONFIG_API_URL}${GETSPONSORSBUDGET}`, data);
    return response.data;
  }
  static async updateSponsorBudget(data: any,uuid:string) {
    const response = await putService.put(`${CONFIG_API_URL}${GETSPONSORSBUDGET}/${uuid}`, data);
    return response.data;
  }
  static async deleteSponsorBudget(uuid:string) {
    const response = await deleteService.delete(`${CONFIG_API_URL}${GETSPONSORSBUDGET}/${uuid}`);
    return response.data;
  }
  static async payBudget(uuid: any,data:any) {
    const response = await postService.post(`${CONFIG_API_URL}${GETSPONSORSBUDGET}/${uuid}/pay`, data);
    return response.data;
  }
  static async getPaymentHistory(uuid:string | undefined) {
    const response = await getService.get(CONFIG_API_URL + GETSPONSORSBUDGET + '/' + uuid + '/' + 'payment-history');
    const data :any = response.data
    return data;
  }
}
